import { PRODUCT_SCREEN_FIELDS } from './product.js';
import { PROFILE_SCREEN_FIELDS } from './profile.js';
import { SCHEDULED_BROADCAST_SCREEN_FIELDS } from './scheduledBroadcast.js';
import { SEARCH_SCREEN_FIELDS } from './search.js';
import { SETTINGS_SCREEN_FIELDS } from './settings.js';
export { BROADCAST_LISTING_FIELDS, BROADCAST_LISTING_TYPE_BUTTON_MIN_HEIGHTS, } from './broadcastListing.js';
export { BROADCAST_SIDE_MENU_BUTTON_IDS, BROADCAST_SIDE_MENU_BUTTONS, BROADCAST_SIDE_MENU_FIELDS, } from './broadcastSideMenu.js';
export const EXTRA_SCREEN_UI_CONFIG_FIELDS = {
    settings: SETTINGS_SCREEN_FIELDS,
    search: SEARCH_SCREEN_FIELDS,
    profile: PROFILE_SCREEN_FIELDS,
    product: PRODUCT_SCREEN_FIELDS,
    scheduledBroadcast: SCHEDULED_BROADCAST_SCREEN_FIELDS,
};
export const EXTRA_SCREEN_UI_CONFIG_NAMES = [
    'settings',
    'search',
    'profile',
    'product',
    'scheduledBroadcast',
];
//# sourceMappingURL=index.js.map